import { usePostHog } from '@posthog/react';
import React, { useEffect } from 'react';
import { getSupabase } from 'src/utils/supabase';

export const PostHogIdentify: React.FC = () => {
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return;

    let unsubscribe: (() => void) | undefined;

    getSupabase().then((supabase) => {
      const {
        data: { subscription },
      } = supabase.auth.onAuthStateChange((event, session) => {
        if (event === 'SIGNED_IN' && session?.user) {
          posthog.identify(session.user.id);
          posthog.setPersonProperties({ email: session.user.email });
        }
        if (event === 'SIGNED_OUT') {
          posthog.reset();
        }
      });
      unsubscribe = subscription?.unsubscribe;
    });

    return () => unsubscribe?.();
  }, [posthog]);

  return null;
};
